import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

import { Student } from '../api/models/Student';
import { fonts, scale } from '../Styles';
import { DateConverters } from '../util/DateConverters';

export const MNOHSRecordStats: React.FC<{ student: Student | undefined }> = ({ student }) => {
  const converter = DateConverters['YYYY-MM-DD'];
  return (
    <View style={styles.container}>
      {/* student statistics */}
      <View style={styles.statistic}>
        {/* GPA */}
        <View style={styles.statisticItemContainer}>
          <Text style={styles.statisticTitle}>GPA</Text>
          <View style={styles.statisticNumberContainer}>
            <Text style={styles.statisticText}>{student?.gpa}</Text>
          </View>
        </View>
        {/* CREDITS */}
        <View style={styles.statisticItemContainer}>
          <Text style={styles.statisticTitle}>Credits</Text>
          <View style={styles.statisticNumberContainer}>
            <Text style={styles.statisticText}>{student?.credits}</Text>
            <View style={styles.hr} />
            <Text style={styles.statisticText}>{student?.creditsOutOf}</Text>
          </View>
        </View>
        {/* RANK */}
        <View style={styles.statisticItemContainer}>
          <Text style={styles.statisticTitle}>RANK</Text>
          <View style={styles.statisticNumberContainer}>
            <Text style={styles.statisticText}>{student?.rank}</Text>
            <View style={styles.hr} />
            <Text style={styles.statisticText}>{student?.rankOutOf}</Text>
          </View>
        </View>
      </View>
      {Boolean(student?.gradeLastChanged) && (
        <View style={styles.dateContainer}>
          <Text style={styles.dateText}>Last updated: {converter.toString(new Date(student?.gradeLastChanged!))}</Text>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#fff',
    marginVertical: scale(8),
    marginHorizontal: scale(-20),
    padding: scale(16),
  },
  statistic: {
    flexDirection: 'row',
  },
  statisticItemContainer: {
    alignItems: 'center',
    flex: 1,
  },
  statisticTitle: {
    ...fonts.descriptionText,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    marginBottom: scale(8),
  },
  statisticNumberContainer: {
    backgroundColor: '#F6F5F6',
    width: '70%',
    minHeight: scale(75),
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 1,
  },
  statisticText: {
    ...fonts.header2,
    textAlign: 'center',
  },
  hr: {
    width: '60%',
    height: 1,
    backgroundColor: '#C0C0C0',
    marginVertical: scale(4),
  },
  dateContainer: {
    marginTop: scale(16),
    alignItems: 'center',
  },
  dateText: {
    ...fonts.descriptionText,
  },
});
